import * as React from "react"
import { NumeralInput, NumeralInputProps } from "../numeral-input/numeral-input"
import { FC, forwardRef, useCallback } from "react"
import { Icon, useDisclose } from "native-base"
import MaterialIcons from "react-native-vector-icons/MaterialIcons"
import { Appearance, Platform, TouchableOpacity } from "react-native"
import moment from "moment/moment"
import * as ImagePicker from "react-native-image-picker"
import { saveFileFromBase64 } from "../../../utils/save-file-from-base64"
import { SamplingCameraWebViewModal } from "../../sampling-camera-web-view-modal/sampling-camera-web-view-modal"

export interface SamplingAverageWeightInputProps extends NumeralInputProps {
  onImageProcessed?: (asset: ImagePicker.Asset) => void,
  onStateProcessed?: (state: any) => void,
}

const InputRightElement: FC<{
  colorScheme?: "light"|"dark",
  onValueProcessed?: (value: number) => void
  onImageProcessed?: (asset: ImagePicker.Asset) => void
  onStateProcessed?: (state: any) => void
}> = function InputRightElement(props) {
  const {
    onImageProcessed,
    onValueProcessed,
    onStateProcessed
  } = props
  const { isOpen, onOpen, onClose } = useDisclose()

  const onSetData = useCallback(async (data: any) => {
    if (data?.value)
      onValueProcessed && onValueProcessed(data.value)
    if (data?.imgBase64 && onImageProcessed) {
      const asset: ImagePicker.Asset = {
        base64: data.imgBase64.split(',')[1],
        uri: Platform.select({
          android: "file://" + await saveFileFromBase64(data.imgBase64, `sampling-average-weight-${moment().format("YYYY-MM-DD-HH-mm-ss")}.png`),
          ios: data.imgBase64,
          web: data.imgBase64,
        }),
        fileName: `sampling-average-weight-${moment().format("YYYY-MM-DD-HH-mm-ss")}.jpg`,
        type: "image/png",
        fileSize: data.imgBase64.length,
      }
      onImageProcessed(asset)
    }
    if (data?.state) {
      onStateProcessed && onStateProcessed(data.state)
    }
    onClose()
  }, [onClose, onImageProcessed, onStateProcessed, onValueProcessed])

  return <>
    <TouchableOpacity onPress={onOpen}>
      <Icon as={<MaterialIcons name="camera" />}
            size={"24px"} mr={"9px"} textAlign="center"
            color="#666666" />
    </TouchableOpacity>
    <SamplingCameraWebViewModal
      isOpen={isOpen}
      onClose={onClose}
      onSetData={onSetData}
    />
  </>
}

/**
 * Describe your component here
 */
export const SamplingAverageWeightInput = forwardRef(function SamplingAverageWeightInput(props: SamplingAverageWeightInputProps, ref: any) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    onChangeNumber, onImageProcessed, onStateProcessed,
    ...rest
  } = props

  return (
    <NumeralInput
      ref={ref}
      colorScheme={colorScheme}
      onChangeNumber={onChangeNumber}
      InputRightElement={<InputRightElement
        colorScheme={colorScheme}
        onValueProcessed={onChangeNumber}
        onImageProcessed={onImageProcessed}
        onStateProcessed={onStateProcessed}
      />}
      {...rest}
    />
  )
})
